import(/* webpackMode: "eager" */ "/vercel/path0/src/app/auth/signup/teacher/page.tsx");
